<template>
  <div>
    <h1 id="js-learning-name" class="learning-item-name center-align">
      {{ name }}
    </h1>
    <div
      id="js-learning-description"
      class="learning-item-description center-align"
    >
      {{ description }}
    </div>
    <base-editor :editable="false" :content="body" />
    <v-checkbox
      class="item-completed"
      :disabled="!enableComplete"
      v-model="updatedStatus"
      :value="status"
      label="Item Completed"
      v-if="showComplete"
    ></v-checkbox>
    <v-btn
      class="default-action-btn"
      id="js-next-button"
      v-if="showComplete && status && nextItemId"
      @click="goToNext"
      >next</v-btn
    >
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import BaseEditor from "@/components/BaseEditor"

export default {
  mixins: [eventMixin],
  components: {
    BaseEditor
  },
  props: {
    id: Number,
    body: String,
    enableComplete: { type: Boolean, default: false },
    showComplete: { type: Boolean, default: false },
    description: String,
    name: String,
    showEdit: { type: Boolean, default: false },
    status: Boolean,
    showTemplates: { type: Boolean, default: true },
    nextItemId: { default: null }
  },
  computed: {
    updatedStatus: {
      get() {
        return this.status
      },
      set(value) {
        this.$store.dispatch("learningItems/updateLearningItem", {
          id: this.id,
          status: value,
          showTemplates: this.showTemplates
        })
      }
    }
  },
  methods: {
    goToNext() {
      this.$router.push({
        name: "learningItemMember",
        params: { id: this.nextItemId }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

.learning-item-name {
  color: $orange;
}
.learning-item-description {
  font-style: italic;
  font-size: 1.4em;
  color: $light-grey;
}
.center-align {
  display: flex;
  justify-content: center;
}
</style>
